/* Garden Kitchen Home storefront behaviour: bag drawer (Shopify Ajax Cart API), welcome offer, gallery, product forms,
   reviews, demo videos. Markup and copy follow the old Next.js storefront. */
(function () {
  'use strict';
  var G = window.GKH;
  var money = G.money;
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]; }); };
  var ICON = {
    x: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x icon" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>',
    menu: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-menu icon" aria-hidden="true"><path d="M4 5h16"/><path d="M4 12h16"/><path d="M4 19h16"/></svg>',
    shield: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield-check icon" aria-hidden="true"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/></svg>',
    zoomIn: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-zoom-in" aria-hidden="true"><circle cx="11" cy="11" r="8"/><line x1="21" x2="16.65" y1="21" y2="16.65"/><line x1="11" x2="11" y1="8" y2="14"/><line x1="8" x2="14" y1="11" y2="11"/></svg>',
    zoomOut: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-zoom-out" aria-hidden="true"><circle cx="11" cy="11" r="8"/><line x1="21" x2="16.65" y1="21" y2="16.65"/><line x1="8" x2="14" y1="11" y2="11"/></svg>'
  };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------------- Cart API ---------------- */
  var BONUS = '_gkh_welcome_bonus';
  var isBonus = function (l) { return !!(l.properties && l.properties[BONUS]); };
  var packOf = function (l) { var o = (l.options_with_values || []).filter(function (x) { return x.name === 'Pack'; })[0]; return o && o.value; };
  var qualifies = function (l) { return (l.handle || l.product_handle) === G.offer.product && packOf(l) === G.offer.pack && !isBonus(l); };
  var current = null, queue = Promise.resolve();

  function request(url, body) {
    var opts = body ? {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)} : {headers: {Accept: 'application/json'}};
    return fetch(root + url, opts).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'Please review your bag.'); e.status = r.status; throw e; } return j; });
    });
  }
  var getCart = function () { return request('cart.js'); };
  // Mutations run one at a time, so quick taps never race each other.
  function serial(fn) { var p = queue.then(fn, fn); queue = p.catch(function () {}); return p; }

  function codesOf(cart) { return (cart.discount_codes || []).map(function (c) { return c.code; }); }
  function setCodes(codes) {
    return request('cart/update.js', {discount: codes.join(',')}).then(function (cart) {
      // Older carts without the Ajax discount field: fall back to the discount URL, which sets the same cart code.
      if (codes.length && !cart.discount_codes) return fetch(root + 'discount/' + encodeURIComponent(codes[codes.length - 1]) + '?redirect=' + encodeURIComponent(root + 'cart.js')).then(getCart);
      return cart;
    });
  }

  /* Welcome offer invariant: while the window is open and the bag holds a paid Chair Shoes 16-pack, the bag also holds
     exactly one free 16-pack of the same variant (line property _gkh_welcome_bonus) and the offer's discount code.
     Otherwise there is no bonus line and no code. If the code doesn't make the bonus free, the bonus is removed. */
  function reconcile(cart) {
    var active = G.offerLeft() > 0;
    var paid = cart.items.filter(qualifies)[0];
    var bonuses = cart.items.filter(isBonus);
    var code = G.offer.code, codes = codesOf(cart), hasCode = codes.some(function (c) { return c.toUpperCase() === code.toUpperCase(); });
    var steps = Promise.resolve(cart);
    var want = active && paid && code;
    var good = want && bonuses.length === 1 && bonuses[0].variant_id === paid.variant_id && bonuses[0].quantity === 1;
    if (!good && bonuses.length) {
      var updates = {}; bonuses.forEach(function (b) { updates[b.key] = 0; });
      steps = steps.then(function () { return request('cart/update.js', {updates: updates}); });
    }
    if (want && !good) steps = steps.then(function () { var props = {}; props[BONUS] = 'yes'; return request('cart/add.js', {items: [{id: paid.variant_id, quantity: 1, properties: props}]}).then(getCart, getCart); });
    if (want && !hasCode) steps = steps.then(function (c) { return setCodes(codesOf(c).concat(code)); });
    if (!want && hasCode) steps = steps.then(function () { return setCodes(codes.filter(function (c) { return c.toUpperCase() !== code.toUpperCase(); })); });
    if (!want && !bonuses.length && !hasCode) return Promise.resolve(cart);
    return steps.then(function () { return getCart(); }).then(function (c) {
      if (!want || !G.offer.verify) return c;
      var applied = (c.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === code.toUpperCase(); })[0];
      var bonus = c.items.filter(isBonus)[0];
      if (applied && applied.applicable && (!bonus || bonus.final_line_price === 0)) return c;
      // The code is missing, used up or not set up to make the pack free: never charge for a "free" pack.
      try { sessionStorage.setItem('gkh-offer-off', '1'); } catch (e) {}
      document.dispatchEvent(new CustomEvent('gkh:offer-off'));
      return reconcile(c);
    });
  }

  function refresh(open) {
    return serial(function () { return getCart().then(reconcile); }).then(function (cart) { render(cart); if (open) openDrawer(); return cart; });
  }
  function add(lines) {
    return serial(function () {
      return request('cart/add.js', {items: lines.map(function (l) { return {id: l.id, quantity: l.quantity}; })})
        .then(getCart).then(reconcile)
        .catch(function (e) { return getCart().then(reconcile).then(function (c) { c._error = e.message; return c; }); });
    }).then(function (cart) { render(cart); openDrawer(); return cart; });
  }
  // Buy now sets these variants to exactly `lines` (pressing it again never stacks), keeps other products, then checks out.
  function buyNow(variantIds, lines) {
    return serial(function () {
      return getCart().then(function (cart) {
        var updates = {}, any = false;
        cart.items.forEach(function (l) { if (variantIds.indexOf(l.variant_id) >= 0 && !isBonus(l)) { updates[l.key] = 0; any = true; } });
        return (any ? request('cart/update.js', {updates: updates}) : Promise.resolve())
          .then(function () { return request('cart/add.js', {items: lines.map(function (l) { return {id: l.id, quantity: l.quantity}; })}); })
          .then(getCart).then(reconcile);
      });
    }).then(function () { location.href = root + 'checkout'; })
      .catch(function (e) { refresh(true).then(function (c) { c._error = e.message; render(c); }); });
  }
  function change(key, quantity) {
    return serial(function () { return request('cart/change.js', {id: key, quantity: Math.max(0, Math.min(99, Math.floor(quantity) || 0))}).then(reconcile).catch(function (e) { return getCart().then(function (c) { c._error = e.message; return c; }); }); }).then(render);
  }

  /* ---------------- Bag rendering (cart.tsx) ---------------- */
  function itemCount(cart) { return cart.items.reduce(function (n, l) { return n + (isBonus(l) ? 0 : l.quantity); }, 0); }
  function lineHtml(l) {
    var opts = l.product_has_only_default_variant ? '' : (l.variant_options || []).join(' / ');
    var img = l.image ? '<img src="' + esc(l.image) + (l.image.indexOf('?') >= 0 ? '&' : '?') + 'width=152" alt="' + esc(l.product_title) + '" width="76" height="76" loading="lazy">' : '';
    var price = l.final_line_price < l.original_line_price ? '<s>' + money(l.original_line_price) + '</s> ' + money(l.final_line_price) : money(l.final_line_price);
    if (isBonus(l)) {
      var left = G.offerLeft();
      return '<article class="cart-item cart-bonus">' + img.replace(/alt="[^"]*"/, 'alt=""') + '<div><h3>Free welcome bonus: ' + esc(l.product_title) + '</h3><p>' + esc(opts) + '</p><div class="cart-item-bottom"><span>' + (left > 0 ? 'Order within <time data-bonus-clock>' + G.offerClock(left) + '</time>' : '') + '</span><span class="cart-item-price">' + (l.final_line_price === 0 ? 'FREE' : price) + '</span></div></div></article>';
    }
    var name = esc(l.product_title);
    return '<article class="cart-item">' + img + '<div><h3><a href="' + esc(l.url) + '">' + name + '</a></h3><p>' + esc(opts) + '</p>' +
      '<div class="cart-item-bottom"><div class="quantity-control"><button aria-label="Decrease ' + name + ' quantity" data-line-step="-1" data-key="' + esc(l.key) + '">−</button><input aria-label="' + name + ' quantity" type="number" min="1" max="99" value="' + l.quantity + '" data-line-qty data-key="' + esc(l.key) + '"><button aria-label="Increase ' + name + ' quantity" data-line-step="1" data-key="' + esc(l.key) + '">+</button></div><span class="cart-item-price">' + price + '</span></div>' +
      '<button class="cart-remove" data-line-remove data-key="' + esc(l.key) + '">Remove</button></div></article>';
  }
  function contentsHtml(cart, drawer) {
    if (!cart.items.length) return '<div class="cart-empty"><h3>Your bag is waiting.</h3><p>Quiet chairs and protected floors start here.</p><a class="button" href="' + root + 'products/chair-shoes">Shop Chair Shoes</a></div>';
    var total = cart.total_price, threshold = G.shipping.threshold, free = total >= threshold;
    var lines = cart.items.filter(function (l) { return !isBonus(l); }).concat(cart.items.filter(isBonus));
    return '<div class="' + (drawer ? 'drawer-scroll' : '') + '"><div class="shipping-progress"><p>' + (free ? 'Your order qualifies for free US shipping.' : 'You’re <strong>' + money(Math.max(0, threshold - total)) + '</strong> away from free US shipping.') + '</p><div class="progress-track"><span style="width:' + Math.min(100, total / threshold * 100) + '%"></span></div></div>' +
      lines.map(lineHtml).join('') + '</div>' +
      '<div class="' + (drawer ? 'drawer-footer' : 'cart-page-summary') + '"><div class="cart-subtotal"><strong>Subtotal</strong><strong>' + money(total) + '</strong></div><p class="small">US shipping: ' + (free ? 'Free' : money(G.shipping.standard)) + '. Final total confirmed at checkout.</p>' +
      (cart._error ? '<p class="form-error" role="alert">' + esc(cart._error) + '</p>' : '') +
      '<a class="button checkout-button" href="' + root + 'checkout" data-checkout>Checkout</a><p class="drawer-guarantee">' + ICON.shield + ' 30-Day Returns · Secure checkout</p>' +
      (drawer ? '<a class="text-link" href="' + root + 'cart">View my bag</a>' : '') + '</div>';
  }
  function render(cart) {
    current = cart;
    var n = itemCount(cart);
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
    document.querySelectorAll('[data-cart-heading-count]').forEach(function (el) { el.textContent = '(' + n + ' ' + (n === 1 ? 'item' : 'items') + ')'; });
    document.querySelectorAll('[data-cart-contents]').forEach(function (el) { el.innerHTML = contentsHtml(cart, el.hasAttribute('data-drawer')); });
    document.dispatchEvent(new CustomEvent('gkh:cart', {detail: cart}));
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-line-step],[data-line-remove]');
    if (!t || !current) return;
    var line = current.items.filter(function (l) { return l.key === t.dataset.key; })[0];
    if (!line) return;
    change(line.key, t.hasAttribute('data-line-remove') ? 0 : line.quantity + Number(t.dataset.lineStep));
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.hasAttribute && t.hasAttribute('data-line-qty')) change(t.dataset.key, Math.max(1, Number(t.value) || 1));
  });

  /* ---------------- Drawer ---------------- */
  var drawer = document.querySelector('[data-cart-drawer]'), previous = null;
  function openDrawer() {
    if (!drawer || drawer.open) return;
    if (document.querySelector('[data-cart-contents]:not([data-drawer])')) return; // already on the bag page
    previous = document.activeElement;
    drawer.showModal(); document.body.style.overflow = 'hidden'; document.documentElement.setAttribute('data-cart-open', '');
  }
  function closeDrawer() {
    if (!drawer || !drawer.open) return;
    drawer.close(); document.body.style.overflow = ''; document.documentElement.removeAttribute('data-cart-open');
    if (previous && previous.focus) previous.focus();
  }
  if (drawer) {
    drawer.addEventListener('cancel', function (e) { e.preventDefault(); closeDrawer(); });
    drawer.addEventListener('click', function (e) { if (e.target === drawer && e.clientX < drawer.getBoundingClientRect().left) closeDrawer(); });
    drawer.querySelector('[data-cart-close]').addEventListener('click', closeDrawer);
  }
  document.querySelectorAll('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function () { setMenu(false); if (current) render(current); openDrawer(); });
  });

  /* ---------------- Header menu ---------------- */
  var menuButton = document.querySelector('[data-menu-toggle]'), menu = document.getElementById('mobile-menu');
  function setMenu(open) {
    if (!menuButton || !menu) return;
    menu.hidden = !open; menuButton.setAttribute('aria-expanded', String(open));
    menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu'); menuButton.innerHTML = open ? ICON.x : ICON.menu;
  }
  if (menuButton) menuButton.addEventListener('click', function () { setMenu(menu.hidden); });
  if (menu) menu.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setMenu(false); menuButton.focus(); } });

  /* ---------------- Offer clock: drawer countdown, and clean-up when the window closes ---------------- */
  var hadOffer = G.offerLeft() > 0;
  setInterval(function () {
    var left = G.offerLeft();
    document.querySelectorAll('[data-bonus-clock]').forEach(function (t) { t.textContent = G.offerClock(left); });
    if (hadOffer && left <= 0) { hadOffer = false; refresh(false); }
    if (!hadOffer && left > 0) hadOffer = true;
  }, 1000);
  document.addEventListener('gkh:offer-off', function () { var b = document.querySelector('[data-offer-banner]'); if (b) b.hidden = true; });

  /* ---------------- Gallery (product-gallery.tsx) ---------------- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var thumbs = [].slice.call(g.querySelectorAll('[data-gallery-thumb]')), main = g.querySelector('[data-gallery-main]');
    var dialog = g.querySelector('[data-gallery-dialog]'), index = 0, zoomed = false;
    function setZoom(z) {
      zoomed = z; if (!dialog) return;
      dialog.querySelector('[data-gallery-canvas]').classList.toggle('is-zoomed', z);
      var b = dialog.querySelector('[data-gallery-zoom]'); b.setAttribute('aria-pressed', String(z)); b.setAttribute('aria-label', z ? 'Zoom out' : 'Zoom in'); b.innerHTML = z ? ICON.zoomOut : ICON.zoomIn;
      dialog.querySelector('[data-gallery-hint]').textContent = z ? 'Scroll to explore the enlarged image' : 'Use + to see the details more closely';
    }
    function choose(i) {
      index = (i + thumbs.length) % thumbs.length;
      var t = thumbs[index], src = t.dataset.src, alt = t.dataset.alt;
      thumbs.forEach(function (x, j) { x.classList.toggle('is-active', j === index); x.setAttribute('aria-pressed', String(j === index)); });
      main.srcset = [400, 700, 1000, 1400].map(function (w) { return src + '&width=' + w + ' ' + w + 'w'; }).join(', ');
      main.src = src + '&width=1000'; main.alt = alt;
      var btn = main.closest('.gallery-enlarge');
      if (btn) { btn.dataset.photoFit = src.indexOf('lifestyle') >= 0 ? 'cover' : 'contain'; btn.setAttribute('aria-label', 'Enlarge image: ' + alt); }
      if (dialog) {
        var big = dialog.querySelector('[data-gallery-big]'); big.src = src + '&width=1800'; big.alt = alt;
        dialog.querySelector('[data-gallery-count]').textContent = 'Image ' + (index + 1) + ' of ' + thumbs.length;
        setZoom(false); dialog.querySelector('[data-gallery-stage]').scrollTo(0, 0);
      }
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { choose(i); }); });
    if (!dialog) return;
    g.querySelectorAll('[data-gallery-open]').forEach(function (b) { b.addEventListener('click', function () { choose(index); dialog.showModal(); document.body.style.overflow = 'hidden'; }); });
    dialog.addEventListener('close', function () { document.body.style.overflow = ''; setZoom(false); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') { e.preventDefault(); choose(index - 1); } if (e.key === 'ArrowRight') { e.preventDefault(); choose(index + 1); } });
    dialog.querySelector('[data-gallery-close]').addEventListener('click', function () { dialog.close(); });
    dialog.querySelector('[data-gallery-zoom]').addEventListener('click', function () { setZoom(!zoomed); dialog.querySelector('[data-gallery-stage]').scrollTo(0, 0); });
    dialog.querySelector('[data-gallery-prev]').addEventListener('click', function () { choose(index - 1); });
    dialog.querySelector('[data-gallery-next]').addEventListener('click', function () { choose(index + 1); });
  });

  /* ---------------- Standard product purchase (product-purchase.tsx) ---------------- */
  var sp = document.querySelector('[data-standard-product]');
  if (sp) {
    var pdata = JSON.parse(document.querySelector('[data-product-data]').textContent);
    var form = sp.querySelector('[data-product-form]'), qty = sp.querySelector('[data-qty]');
    var params = new URLSearchParams(location.search);
    var variant = pdata.variants.filter(function (v) { return String(v.id) === params.get('variant'); })[0] || pdata.variants.filter(function (v) { return v.available; })[0] || pdata.variants[0];
    var selects = [].slice.call(sp.querySelectorAll('[data-option-index]'));
    var canBuy = function () { return !pdata.coming && variant.available && variant.inventory > 0; };
    var showVariant = function (writeUrl) {
      sp.querySelector('[data-product-price]').innerHTML = variant.priceHtml;
      sp.querySelector('[data-sticky-price]').innerHTML = variant.stickyHtml;
      selects.forEach(function (s) { s.value = variant.options[Number(s.dataset.optionIndex)]; });
      var ok = canBuy(), addBtn = sp.querySelector('[data-add]'), buy = sp.querySelector('[data-buy-now]'), st = sp.querySelector('[data-sticky-add]');
      addBtn.disabled = !ok; addBtn.textContent = pdata.coming ? 'Coming soon' : ok ? 'Add to cart' : 'Sold out';
      if (buy) buy.disabled = !ok;
      st.disabled = !ok; st.textContent = ok ? 'Add to cart' : 'Sold out';
      qty.max = Math.min(99, variant.inventory || 99); if (Number(qty.value) > Number(qty.max)) qty.value = qty.max;
      if (writeUrl) { var u = new URL(location.href); u.searchParams.set('variant', variant.id); history.replaceState(history.state, '', u); }
    };
    selects.forEach(function (s) {
      s.addEventListener('change', function () {
        var i = Number(s.dataset.optionIndex), val = s.value;
        var matches = pdata.variants.filter(function (v) { return v.options[i] === val; });
        var score = function (v) { return v.options.filter(function (o, j) { return j !== i && o === variant.options[j]; }).length; };
        matches.sort(function (a, b) { return score(b) - score(a); });
        if (matches[0]) { variant = matches[0]; showVariant(true); }
      });
    });
    var quantity = function () { return Math.max(1, Math.min(Number(qty.max) || 99, Math.floor(Number(qty.value)) || 1)); };
    sp.querySelectorAll('[data-qty-step]').forEach(function (b) { b.addEventListener('click', function () { qty.value = Math.max(1, Math.min(Number(qty.max) || 99, quantity() + Number(b.dataset.qtyStep))); }); });
    qty.addEventListener('change', function () { qty.value = quantity(); });
    form.addEventListener('submit', function (e) { e.preventDefault(); if (canBuy()) add([{id: variant.id, quantity: quantity()}]); });
    var buyBtn = sp.querySelector('[data-buy-now]');
    if (buyBtn) buyBtn.addEventListener('click', function () { if (canBuy()) buyNow(pdata.variants.map(function (v) { return v.id; }), [{id: variant.id, quantity: quantity()}]); });
    sp.querySelector('[data-sticky-add]').addEventListener('click', function () { if (canBuy()) add([{id: variant.id, quantity: quantity()}]); });
    var stickyBar = sp.querySelector('[data-sticky-purchase]');
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { stickyBar.hidden = !(!en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(sp.querySelector('[data-add]'));
    showVariant(false);
  }

  /* ---------------- Chair page helpers ---------------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="#chair-size-options"]');
    if (a) { var d = document.getElementById('chair-size-options'); if (d) d.open = true; }
  });

  /* ---------------- Reviews box (reviews-box.tsx) ---------------- */
  document.querySelectorAll('[data-rb]').forEach(function (box) {
    var cards = [].slice.call(box.querySelectorAll('.rb-card')), page = Number(box.dataset.rbPage) || 12;
    var status = box.querySelector('.rb-load-status'), visible = Math.min(page, cards.length);
    function show() { cards.forEach(function (c, i) { c.hidden = i >= visible; }); status.textContent = 'Showing ' + visible + ' of ' + cards.length + ' reviews'; }
    if (visible < cards.length) {
      if (!('IntersectionObserver' in window)) { visible = cards.length; show(); }
      else {
        var io = new IntersectionObserver(function (en) {
          if (!en.some(function (x) { return x.isIntersecting; })) return;
          visible = Math.min(visible + page, cards.length); show();
          if (visible >= cards.length) io.disconnect(); else { io.unobserve(status); requestAnimationFrame(function () { io.observe(status); }); }
        }, {rootMargin: '400px 0px'});
        io.observe(status);
      }
    }
    box.addEventListener('click', function (e) {
      var more = e.target.closest('.rb-more');
      if (more) { var t = more.parentNode.querySelector('.rb-text'), open = !t.classList.contains('is-open'); t.classList.toggle('is-open', open); more.setAttribute('aria-expanded', String(open)); more.textContent = open ? 'See less' : 'See more'; return; }
      var photo = e.target.closest('.rb-photo'), dlg = box.querySelector('.rb-lightbox');
      if (photo && dlg) {
        var img = dlg.querySelector('img'); img.src = photo.dataset.rbFull; img.alt = photo.querySelector('img').alt; img.width = Number(photo.dataset.rbW); img.height = Number(photo.dataset.rbH); img.hidden = false;
        dlg.showModal();
      }
    });
    var dlg = box.querySelector('.rb-lightbox');
    if (dlg) {
      dlg.querySelector('.rb-close').addEventListener('click', function () { dlg.close(); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    }
  });

  /* ---------------- Demo videos (product-demo-video.tsx): play muted while in view ---------------- */
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('[data-demo-video]').forEach(function (video) {
    var inView = false, userPaused = false;
    function sync() { if (!inView || document.hidden || reduced.matches) video.pause(); else if (!userPaused) { var p = video.play(); if (p && p.catch) p.catch(function () {}); } }
    video.muted = true;
    video.addEventListener('pause', function () { if (inView && !document.hidden && !reduced.matches) userPaused = true; });
    video.addEventListener('play', function () { userPaused = false; });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { inView = en[0].isIntersecting && en[0].intersectionRatio >= 0.2; sync(); }, {threshold: [0, 0.2]}).observe(video);
    document.addEventListener('visibilitychange', sync);
  });

  /* ---------------- Catalog sort ---------------- */
  var sort = document.querySelector('[data-collection-sort]');
  if (sort) sort.addEventListener('change', function () { var u = new URL(location.href); if (sort.value) u.searchParams.set('sort_by', sort.value); else u.searchParams.delete('sort_by'); u.searchParams.delete('page'); location.href = u.toString(); });

  /* ---------------- Privacy choices (privacy-choices.tsx) ---------------- */
  var toggle = document.querySelector('[data-privacy-toggle]');
  if (toggle) {
    var allowed = function () {
      if (navigator.globalPrivacyControl === true || navigator.doNotTrack === '1') return false;
      try { return localStorage.getItem('gkh-marketing-consent') !== 'no'; } catch (e) { return false; }
    };
    toggle.checked = allowed();
    toggle.addEventListener('change', function () { document.querySelector('[data-privacy-status]').hidden = true; });
    document.querySelector('[data-privacy-save]').addEventListener('click', function () {
      try { localStorage.setItem('gkh-marketing-consent', toggle.checked ? 'yes' : 'no'); } catch (e) {}
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && cp.setTrackingConsent) { try { cp.setTrackingConsent({analytics: toggle.checked, marketing: toggle.checked, preferences: true, sale_of_data: toggle.checked}, function () {}); } catch (e) {} }
      document.querySelector('[data-privacy-status]').hidden = false;
      setTimeout(function () { location.reload(); }, 400);
    });
  }

  /* ---------------- Start ---------------- */
  window.GKHCart = {add: add, buyNow: buyNow, refresh: refresh, open: openDrawer, close: closeDrawer};
  document.dispatchEvent(new CustomEvent('gkh:ready'));
  refresh(false).catch(function () { render({items: [], total_price: 0}); });
})();
